import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const ProcessContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
  }

  .ant-table-pagination.ant-pagination {
    margin-bottom: 0;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }
`;

export const ActionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 2px;
  > button {
    background: transparent;
    border: none;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme["@default-color"]};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .pencilEdit,
  .trashIcon {
    cursor: pointer;
  }
`;

export const ProcessIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
  color: theme["@primary-color-brand"],
};

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};
